import './IngestionSummary.scss';
import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import {SummaryStats} from '../../../shared/types';
import ArrButton from '../../common/arr-button/ArrButton';
import {useNavigate} from 'react-router-dom';

interface StatsDisplayProps {
  stats: SummaryStats;
  showApoUpdates: boolean;
}
const IngestionSummary: React.FC<StatsDisplayProps> = ({
  stats,
  showApoUpdates,
}) => {
  const navigate = useNavigate();

  // const handleProcessingSync = () => {
  //   navigate('/ProcessingSync');
  // };

  return (
    <Box className="view-ingestionSummary-header">
      <Box className="view-ingestion-title">
        <Typography
          className="typo-text.subhead2_size"
          data-testid={`ingestion-summary-total-mapped-ingestion`}
        >
          {t('ingestions.mapped.totalMappedIngestion')}{' '}
          <Typography
            component="span"
            className="typo-text.body2_size text-body-subtle"
            data-testid={`ingestion-summary-mapped`}
          >
            ({stats.mappedIngests})
          </Typography>
        </Typography>
        <Typography
          className="typo-text.body2_size text-body-subtle "
          data-testid={`ingestion-summary-unique`}
        >
          {`${stats.uniqueIngests} ` +
            t('ingestions.mapped.ingestionsCountText')}
        </Typography>
      </Box>
      <Box className="view-ingestion-actions">
        {showApoUpdates && (
          <ArrButton
            aria-label={t('ingestions.apoUpdates')}
            type="submit"
            variant="secondary"
            title="APO Updates"
            size="small"
            // TODO : Please change the Route to navigate to the APO History Page
            onClick={() => navigate('/Ingestion/apo')}
            dataTestId="ingestion-header-apoUpdates-btn"
          >
            {t('ingestions.apoUpdates')}
          </ArrButton>
        )}
        {/* Hiding the processing sync button */}
        {/* {showApoUpdates && (
          <ArrButton
            onClick={handleProcessingSync}
            aria-label={t('ingestions.ProcessingSync')}
            variant="secondary"
            size="small"
            dataTestId="ingestion-header-ProcessingSync-button"
          >
            {t('ingestions.mapped.processingsync.processingSync')}
          </ArrButton>
        )} */}
      </Box>
    </Box>
  );
};

export default IngestionSummary;
